import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'behaviouralVisitationDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'behaviouralVisitationDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'behaviouralVisitationDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
